<div class="flex w-full items-center">
  @if (interactive) {
    <button type="button" class="vw-list-row flex min-w-0 flex-1 items-center gap-3 px-4 py-2 text-left"
      [ngClass]="heightClass" [attr.aria-current]="checked ? 'true' : null" (click)="rowClick.emit()">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
  } @else {
    <div class="vw-list-row vw-list-row--static flex min-w-0 flex-1 items-center gap-3 px-4 py-2 text-left"
      [ngClass]="heightClass">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  }
  <!-- Une action à part, à côté du bouton de la ligne et non dedans (fermer). -->
  <span class="vw-list-row__action flex shrink-0 items-center"><ng-content select="[vwListRowAction]"></ng-content></span>
</div>

<!-- Contenu commun au bouton et à la ligne d'information : la vignette n'est
     projetée qu'une fois, quel que soit l'élément qui la porte. -->
<ng-template #content>
  <span class="vw-list-row__thumb flex shrink-0 items-center justify-center"
    [ngClass]="thumb === 'bare' ? '' : {
      'rounded-pill': true,
      'h-10 w-10 p-2': thumbSize === 40,
      'h-[26px] w-[26px] p-1': thumbSize === 26,
      'bg-vw-surface-tint text-vw-primary-ink': tone === 'default',
      'bg-vw-warn-bg text-vw-warn-ink': tone === 'warn' || tone === 'stale',
      'bg-vw-surface-sunk text-vw-danger': tone === 'danger',
      'bg-vw-surface-sunk text-vw-body': tone === 'neutral'
    }" aria-hidden="true"><ng-content select="[vwListRowIcon]"></ng-content></span>
  <!-- Le texte et la droite : avec `trailingWraps`, la droite passe dessous quand le texte n'a plus la place. -->
  <span class="flex min-w-0 grow items-center gap-3" [class.flex-wrap]="trailingWraps">
    <span class="flex min-w-0 grow flex-col" [class.basis-24]="trailingWraps">
      <span class="font-semibold" [ngClass]="[dense ? 'text-body-s' : 'text-body', titleColor]">{{ title }}</span>
      @if (subtitle) {
        <span class="text-vw-muted" [ngClass]="dense ? 'text-caption font-normal' : 'text-body-s'">{{ subtitle }}</span>
      }
      <!-- Sous-titre composé (pastille et texte) : sans contenu projeté, rien. -->
      <span class="vw-list-row__subtitle flex flex-wrap items-center gap-x-1.5 gap-y-1 text-vw-muted"
        [ngClass]="dense ? 'text-caption font-normal' : 'text-body-s'"><ng-content select="[vwListRowSubtitle]"></ng-content></span>
    </span>
    <span class="vw-list-row__trailing flex shrink-0 items-center"><ng-content select="[vwListRowTrailing]"></ng-content></span>
  </span>
  @if (checked) {
    <vw-check-icon class="block h-6 w-6 shrink-0 text-vw-primary" aria-hidden="true" />
  }
  @if (chevron && interactive) {
    <vw-chevron-right-icon class="block h-6 w-6 shrink-0 text-vw-icon-idle" aria-hidden="true" />
  }
</ng-template>
